import { Box } from '@mui/material';
import { TimeFormats } from '@uplift/constants';
import { useEffect, useState } from 'react';
import { Button } from '../../Button';
import { useStyles } from '../styles';
import { OnSetSelectedSlotType, Timeslot } from './../types';

export type MapTimeSlotsProps = {
  slots: Timeslot[];
  onSetSelectedSlot: OnSetSelectedSlotType;
};

export const MapTimeSlots: React.FC<MapTimeSlotsProps> = props => {
  const [ showMore, setShowMore ] = useState(false);
  const { classes } = useStyles();

  // this will set the showMore state back to default when date is changed
  useEffect(() => setShowMore(false), [ props.slots ]);

  const limitedResults = props.slots.length > 8 && !showMore;
  const slots = limitedResults ? props.slots.slice(0, 7) : props.slots;

  return (
    <Box className={classes.slots}>
      {slots.map((slot) => {
        return (
          <Button key={slot.toString()} variant="contained" color="secondary" onClick={() => props.onSetSelectedSlot(slot)}>
            {slot.format(TimeFormats['h:mm a'])}
          </Button>
        );
      })}
      {limitedResults && <Button size="small" onClick={() => setShowMore(true)}>More</Button>}
    </Box>
  );
};
